import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  raritys: [],
};


const slice = createSlice({
  name: 'rarity',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET rarity
    getraritySuccess(state, action) {
      state.isLoading = false;
      state.raritys = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


export function getRaritys(paginate, pageIndex, pageSize) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {};
      if (paginate) params.paginate = paginate;
      if (pageIndex) params.page = pageIndex;
      if (pageSize) params.per_page = pageSize;
      const response = await axios.get('/api/clinic/terms_n_conditions', { params });
      dispatch(slice.actions.getraritySuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


